import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import { CiLocationArrow1 } from "react-icons/ci";
import Empty from '../../controls/Empty'
import Card from '../../controls/Card'
import { MdErrorOutline } from 'react-icons/md'
import * as opdCentersCrud from "../../../configurations/crud/opdCentersCrud"
import Paging from '../../controls/Paging'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR, PAGE_SIZE } from '../../../configurations/initUrls';
import Input from '../../controls/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUser } from '@fortawesome/free-solid-svg-icons';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { Link } from 'react-router-dom';
import { BiSolidRightArrowSquare } from "react-icons/bi";
import { GetEGenderName } from '../../../configurations/enums/EGender';
import StatusContainer from '../../controls/StatusContainer';
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool';
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus';
import { IoMdOpen } from 'react-icons/io';
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import { EOPDCenterStatusBg, GetEOPDCenterStatusName } from '../../../configurations/enums/EOPDCenterStatus';
import * as doctorsSpecialisation from '../../../configurations/crud/doctorsSpecialisation'
import Dp from '../users/Dp';
import useGlobalLoader from '../../../configurations/useGlobalLoader';

const initValues = {
  PageNo: 1,
  PageSize: 10,
  SearchTerm: "",
  SpecializationId: undefined,
}

export default function CenterByActiveCenterWithSpecialization() {
  const { start, end } = useGlobalLoader()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);
  const [specializationData, setSpecializationData] = useState([]);
  const [lodingSpecializationCrud, setLodingSpecializationCrud] = useState(false)

  useEffect(() => {
    setSearchDebounce(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    onSearch()
  }, [searchDebounce])

  useEffect(() => {
    if (specializationData.length == 0)
      GetSpecialisations()
  }, [])

  useEffect(() => {
    onSearch()
  }, [search.SpecializationId])

  const GetSpecialisations = () => {
    setLoding(true)
    start()
    doctorsSpecialisation.GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setSpecializationData(mdata.data)
      } else {
        setSpecializationData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setSpecializationData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const OnPageChange = (e) => {
    const { value } = e.target;
    setSearch({ ...search, PageNo: value })
    onSearchNew({
      PageNo: value,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm,
      SpecializationId: search.SpecializationId
    })
  }
  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }
  const onSearch = () => {
    if (search.SpecializationId)
      onSearchNew({
        PageNo: 1,
        PageSize: search.PageSize,
        SearchTerm: searchTerm,
        SpecializationId: search.SpecializationId
      })
  }
  const onSearchNew = (search) => {
    GetByActiveCenterWithSpecialization(search)
  }
  const doRefresh = () => {
    setSearch({ ...search, PageNo: 1 })
    onSearchNew({
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm,
      SpecializationId: search.SpecializationId
    })
  }

  const GetByActiveCenterWithSpecialization = (params) => {
    setLoding(true)
    start()
    opdCentersCrud.GetByActiveCenterWithSpecialization(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <div className='flex flex-col '>
      <div className='flex flex-col sm:flex-row sm:space-x-3'>
        <div className='w-full py-3'>
          <label for="specialisationId" class="block mb-2 text-sm font-medium text-gray-900">Specialisation</label>
          {!lodingSpecializationCrud ?
            <select class="drop-down" value={search.SpecializationId} onChange={(e) => setSearch({ ...search, SpecializationId: e.target.value })}>
              <option value={0} selected>Select Specialisation...</option>
              {specializationData.map((item) =>
                <option value={item.id}>{item.name} ({item.shortName})</option>
              )}
            </select>
            : <select disabled class="drop-down">
              <option >Loading Specialisation...</option>
            </select>
          }
        </div>
        <div className='w-full py-3'>
          <label for="specialisationId" class="block mb-2 text-sm font-medium text-gray-900 ">Search</label>
          <Input Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
            onChange={onSearchChange}
            placeholder="Search Doctors"></Input>
        </div>
      </div>
      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
        <div class="relative overflow-x-auto">
          {
            !loding ?
              userData.length > 0 ?
                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-200 ">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div class="flex items-center">
                          <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
                          <label for="checkbox-all" class="sr-only">checkbox</label>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        #

                      </th>
                      <th scope="col" class="px-6 py-3">
                        Center Name
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Address
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Phone
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Used Balance
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Doctor's Status
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Status
                      </th>

                      <th scope="col" class="px-6 py-3">
                        Photo
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((item, index) =>
                      <tr class="bg-white border-b  hover:bg-gray-100 ">
                        <td class="w-4 px-6 py-2">
                          <div class="flex items-center">
                            <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
                            <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                          </div>
                        </td>

                        <td class="px-6 py-2">
                          {item.id}
                        </td>
                        <td class="px-6 py-2">
                          {item.centerName}
                        </td>
                        <td class="px-6 py-2">
                          {item.address}, {item.city.name}, {item.city.state.name}
                        </td>
                        <td class="px-6 py-2">
                          {item.phone}
                        </td>
                        <td class="px-6 py-2">
                          {item.opdUsedBalance}
                        </td>
                        <td class="px-6 py-2">
                          <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} />
                        </td>
                        <td class="px-6 py-2">
                          <StatusContainer bg={EOPDCenterStatusBg(item.status)} text={GetEOPDCenterStatusName(item.status)} />
                        </td>
                        <td class="px-6 py-2">
                          <Dp user={item.user} height={"h-9"} width={"w-9"} />
                        </td>
                        <td class="flex items-center px-6 py-2 sm:w-20">
                          <Link to={"/opdcenters/" + item.id + "/view"} class="cursor-pointer text-2xl  text-sky-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg" title='Enable'><IoMdOpen /></Link>
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
                : <Empty>
                  No Items Found.
                </Empty>
              : <LoadingContainer />
          }
        </div>
      </Paging>
    </div>
  )
}

